import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddCertificate from './UploadCert/AddCertificate.component';
import ListOfUserCertificates from './ListOfCertificates.component';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';
const CertificatesInner = ({ user }) => {
  const [showCerts, setShowCerts] = useState(true);
  return (
    <>
      <SecondaryButton
        functionName={() => setShowCerts(!showCerts)}
        span={showCerts ? 'Add Certificate' : 'View Certificates'}
      />
      {showCerts ? <ListOfUserCertificates user={user} /> : <AddCertificate />}
    </>
  );
};
CertificatesInner.propTypes = {
  user: PropTypes.object,
};

export default CertificatesInner;
